import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

const AutoPlanHouseVisitStatus = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Automatisch status 'Ingepland'</h2>
            <p>
                Zet aan om de status van een huishouden automatisch op 'Ingepland' te zetten zodra een huisbezoek wordt ingepland.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Automatisch op 'Ingepland' zetten</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"AutoPlanHouseVisitStatus"}
                        collection={"CompagnyMeta"}
                        value={comp.AutoPlanHouseVisitStatus}
                    />
                </div>
            ))}
        </div>
    );
};

export default AutoPlanHouseVisitStatus;
